import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { validateSessionId } from '../../ApiHandler/PaymentFunctions';
import logo from '../../Assets/logo.png';
import '../Styles/PaymentStatus.css';

const PaymentSuccess = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const sessionId = query.get('session_id');

        if (!sessionId) {
            setError('Missing session ID');
            setLoading(false);
            return;
        }
        // Validate the session ID with your backend
        validateSessionId(sessionId, setSuccess, setError, setLoading);
    }, [location.search]);

    // Add this useEffect for handling error and redirecting
    useEffect(() => {
        // If error or invalid session, redirect back to home page or payment page
        if (error) {
            const timer = setTimeout(() => {
                navigate('/dashboard');
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [error, navigate]);

    if (loading) {
        return (
            <div className="payment-status-container">
                <div className="payment-status-card loading-card">
                    <div className="spinner"></div>
                    <h2>Processing...</h2>
                    <p>Please wait while we verify your payment</p>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="payment-status-container">
                <div className="payment-status-card error-card">
                    <div className="status-icon error-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="15" y1="9" x2="9" y2="15"></line>
                            <line x1="9" y1="9" x2="15" y2="15"></line>
                        </svg>
                    </div>
                    <h1>Something Went Wrong</h1>
                    <p className="error-message">
                        We encountered an issue processing your payment. 
                        Don't worry, you haven't been charged.
                    </p>
                    <p className="redirect-message">Redirecting to dashboard in 3 seconds...</p>
                    <button onClick={() => navigate('/dashboard')} className="status-button error-button">
                        Return to Dashboard
                    </button>
                </div>
            </div>
        );
    }

    if (success) {
        return (
            <div className="payment-status-container">
                <div className="payment-status-card success-card">
                    <img src={logo} alt="GetQuickCare Logo" className="gqc-logo" />
                    <div className="status-icon success-icon">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                            <path d="M20 6L9 17l-5-5"></path>
                        </svg>
                    </div>
                    <h1>Payment Method Added Successfully!</h1>
                    <p className="success-message">
                        Your payment method has been securely saved to your account.
                    </p>
                    <div className="info-box">
                        <div className="info-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <span>Your card details are encrypted and secure</span>
                        </div>
                        <div className="info-item">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"></path>
                            </svg>
                            <span>You can now order test kits</span>
                        </div>
                    </div>
                    <div className="button-group">
                        <button onClick={() => navigate('/dashboard')} className="status-button primary-button">
                            Go to Dashboard
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="payment-status-container">
            <div className="payment-status-card error-card">
                <div className="status-icon error-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="15" y1="9" x2="9" y2="15"></line>
                        <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                </div>
                <h1>Failed to Process Payment</h1>
                <p className="error-message">
                    We couldn't process your payment method at this time.
                </p>
                <button onClick={() => navigate('/dashboard')} className="status-button error-button">
                    Return to Dashboard
                </button>
            </div>
        </div>
    );
};

export default PaymentSuccess;